// Demo/testing identity: the user is whoever the URL says, e.g.
//   https://host/user_id=testuser      (path form — easy to type and share)
//   https://host/?user_id=testuser     (query form — also ?user= / ?uid=)
// Every API call sends it as X-User-ID, which the backend uses to keep each user's
// workspaces, files and annotations separate. There is no password: it's for demos.

const USER_ID_RE = /^[A-Za-z0-9._@-]{1,64}$/;
const LAST_USER_KEY = "airpdf:last-user";

export const isValidUserId = (id) => USER_ID_RE.test(id || "");

/** Turns whatever was typed into a valid id: "Gaurav Nahar" → "gaurav-nahar". */
export const normalizeUserId = (raw) =>
    (raw || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9._@-]/g, "")
        .slice(0, 64);

export const getUserIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    let id = params.get("user_id") || params.get("user") || params.get("uid");
    if (!id) {
        const match = window.location.pathname.match(/\/(?:user_id|user|uid)=([^/?#]+)/);
        if (match) id = decodeURIComponent(match[1]);
    }
    id = (id || "").trim();
    return isValidUserId(id) ? id : "";
};

export const userHomeUrl = (id) => `${window.location.origin}/user_id=${encodeURIComponent(id)}`;

// Remembered only to offer "Continue as …" on the sign-in screen.
export const rememberUser = (id) => {
    try { localStorage.setItem(LAST_USER_KEY, id); } catch { /* storage unavailable */ }
};
export const getLastUser = () => {
    try {
        const id = localStorage.getItem(LAST_USER_KEY);
        return isValidUserId(id) ? id : "";
    } catch {
        return "";
    }
};
